import React from "react";
import toast from "react-hot-toast";
import { useLocation, useNavigate } from "react-router";

function BlogCard(props: any) {
  const location = useLocation();
  const { Heading, Body, src, date, index, id } = props;
  let navigate = useNavigate();

  const navigateTo = (node: any) => {
    node = location?.pathname?.includes("blog")
      ? node.replace(/\s/g, "-").toLowerCase()
      : node;

    navigate(
      `/${location?.pathname?.includes("blog") ? "blog" : "whitepaper"}/${node}`,
      { state: { id: { id } } }
    );
  };
  return (
    <div
      data-aos="fade-up"
      className="h-auto w-full"
      data-aos-anchor-placement="top-bottom"
      data-aos-delay={`${index * 50}`}
    >
      <div
        onClick={() => {
          navigateTo(location?.pathname?.includes("blog") ? Heading : id);
        }}
        className="cursor-pointer  text-black-75 lg:h-full  rounded-[10px] bg-[ #FFFFFF] shadow-md"
      >
        <img
          className=" w-full  lg:max-h-[300px] object-cover rounded-t-[10px]"
          src={`${src}`}
          alt={Heading}
        />
        <div className=" p-6 rounded-b-[10px]   ">
          <div className=" flex  items-center gap-2">
            <svg
              width="14"
              height="14"
              viewBox="0 0 14 14"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M9.31699 10.0167L10.017 9.31666L7.50033 6.79999V3.66666H6.50033V7.19999L9.31699 10.0167ZM7.00033 13.3333C6.12255 13.3333 5.29766 13.1667 4.52566 12.8333C3.75321 12.5 3.08366 12.05 2.51699 11.4833C1.95033 10.9167 1.50033 10.2471 1.16699 9.47466C0.833659 8.70266 0.666992 7.87777 0.666992 6.99999C0.666992 6.12221 0.833659 5.2971 1.16699 4.52466C1.50033 3.75266 1.95033 3.08332 2.51699 2.51666C3.08366 1.94999 3.75321 1.49999 4.52566 1.16666C5.29766 0.833323 6.12255 0.666656 7.00033 0.666656C7.8781 0.666656 8.70321 0.833323 9.47566 1.16666C10.2477 1.49999 10.917 1.94999 11.4837 2.51666C12.0503 3.08332 12.5003 3.75266 12.8337 4.52466C13.167 5.2971 13.3337 6.12221 13.3337 6.99999C13.3337 7.87777 13.167 8.70266 12.8337 9.47466C12.5003 10.2471 12.0503 10.9167 11.4837 11.4833C10.917 12.05 10.2477 12.5 9.47566 12.8333C8.70321 13.1667 7.8781 13.3333 7.00033 13.3333ZM7.00033 12.3333C8.4781 12.3333 9.73655 11.814 10.7757 10.7753C11.8143 9.73621 12.3337 8.47777 12.3337 6.99999C12.3337 5.52221 11.8143 4.26377 10.7757 3.22466C9.73655 2.18599 8.4781 1.66666 7.00033 1.66666C5.52255 1.66666 4.26433 2.18599 3.22566 3.22466C2.18655 4.26377 1.66699 5.52221 1.66699 6.99999C1.66699 8.47777 2.18655 9.73621 3.22566 10.7753C4.26433 11.814 5.52255 12.3333 7.00033 12.3333Z"
                fill="#8A8A8A"
              />
            </svg>
            <div className="text-xs font-custom text-[#8A8A8A]">{date}</div>
          </div>
          <div
            className={`font-custom text-xl md:text-2xl lg:min-h-[64px]  max-h-[130px] cardClamp font-bold my-4`}
          >
            {Heading}
          </div>
          <div className="text-sm md:text-base font-custom pb-4">{Body}</div>

          <div className=" flex items-center justify-end gap-7">
            <svg
              onClick={(e) => {
                e.stopPropagation();
                navigator.clipboard.writeText(
                  `${window?.location?.href}/${location?.pathname?.includes("blog") ? Heading.replace(/\s/g, "-").toLowerCase() : id}`
                );
                toast?.success("Link Copied To Clipboard");
              }}
              width="14"
              height="16"
              viewBox="0 0 14 16"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M11.833 15.3125C11.258 15.3125 10.7705 15.1125 10.3705 14.7125C9.97051 14.3125 9.77051 13.825 9.77051 13.25C9.77051 13.1625 9.77676 13.0655 9.78926 12.959C9.80176 12.853 9.82676 12.7625 9.86426 12.6875L4.31426 9.425C4.11426 9.625 3.88926 9.78125 3.63926 9.89375C3.38926 10.0062 3.12051 10.0625 2.83301 10.0625C2.25801 10.0625 1.77051 9.8625 1.37051 9.4625C0.970508 9.0625 0.770508 8.575 0.770508 8C0.770508 7.425 0.970508 6.9375 1.37051 6.5375C1.77051 6.1375 2.25801 5.9375 2.83301 5.9375C3.12051 5.9375 3.38926 5.99375 3.63926 6.10625C3.88926 6.21875 4.11426 6.375 4.31426 6.575L9.86426 3.3125C9.82676 3.2375 9.80176 3.14675 9.78926 3.04025C9.77676 2.93425 9.77051 2.8375 9.77051 2.75C9.77051 2.175 9.97051 1.6875 10.3705 1.2875C10.7705 0.8875 11.258 0.6875 11.833 0.6875C12.408 0.6875 12.8955 0.8875 13.2955 1.2875C13.6955 1.6875 13.8955 2.175 13.8955 2.75C13.8955 3.325 13.6955 3.8125 13.2955 4.2125C12.8955 4.6125 12.408 4.8125 11.833 4.8125C11.5455 4.8125 11.2768 4.75625 11.0268 4.64375C10.7768 4.53125 10.5518 4.375 10.3518 4.175L4.80176 7.4375C4.83926 7.5125 4.86426 7.6 4.87676 7.7C4.88926 7.8 4.89551 7.9 4.89551 8C4.89551 8.0875 4.88926 8.18425 4.87676 8.29025C4.86426 8.39675 4.83926 8.4875 4.80176 8.5625L10.3518 11.825C10.5518 11.625 10.7768 11.4688 11.0268 11.3563C11.2768 11.2438 11.5455 11.1875 11.833 11.1875C12.408 11.1875 12.8955 11.3875 13.2955 11.7875C13.6955 12.1875 13.8955 12.675 13.8955 13.25C13.8955 13.825 13.6955 14.3125 13.2955 14.7125C12.8955 15.1125 12.408 15.3125 11.833 15.3125ZM11.833 3.6875C12.0955 3.6875 12.3175 3.59675 12.499 3.41525C12.68 3.23425 12.7705 3.0125 12.7705 2.75C12.7705 2.4875 12.68 2.2655 12.499 2.084C12.3175 1.903 12.0955 1.8125 11.833 1.8125C11.5705 1.8125 11.3488 1.903 11.1678 2.084C10.9863 2.2655 10.8955 2.4875 10.8955 2.75C10.8955 3.0125 10.9863 3.23425 11.1678 3.41525C11.3488 3.59675 11.5705 3.6875 11.833 3.6875ZM2.83301 8.9375C3.09551 8.9375 3.31751 8.84675 3.49901 8.66525C3.68001 8.48425 3.77051 8.2625 3.77051 8C3.77051 7.7375 3.68001 7.51575 3.49901 7.33475C3.31751 7.15325 3.09551 7.0625 2.83301 7.0625C2.57051 7.0625 2.34876 7.15325 2.16776 7.33475C1.98626 7.51575 1.89551 7.7375 1.89551 8C1.89551 8.2625 1.98626 8.48425 2.16776 8.66525C2.34876 8.84675 2.57051 8.9375 2.83301 8.9375ZM11.833 14.1875C12.0955 14.1875 12.3175 14.0967 12.499 13.9152C12.68 13.7342 12.7705 13.5125 12.7705 13.25C12.7705 12.9875 12.68 12.7658 12.499 12.5848C12.3175 12.4033 12.0955 12.3125 11.833 12.3125C11.5705 12.3125 11.3488 12.4033 11.1678 12.5848C10.9863 12.7658 10.8955 12.9875 10.8955 13.25C10.8955 13.5125 10.9863 13.7342 11.1678 13.9152C11.3488 14.0967 11.5705 14.1875 11.833 14.1875Z"
                fill="#404041"
              />
            </svg>
            <svg
              onClick={(e) => {
                e.stopPropagation();
                navigator.clipboard.writeText(Heading);
                toast?.success("Copied To Clipboard");
              }}
              width="12"
              height="14"
              viewBox="0 0 12 14"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M1.6459 13.975C1.2709 13.975 0.952148 13.8437 0.689648 13.5812C0.427148 13.3187 0.295898 13 0.295898 12.625V3.1H1.4209V12.625C1.4209 12.6875 1.44265 12.7405 1.48615 12.784C1.53015 12.828 1.5834 12.85 1.6459 12.85H8.9209V13.975H1.6459ZM4.2709 11.35C3.8959 11.35 3.57715 11.2187 3.31465 10.9562C3.05215 10.6937 2.9209 10.375 2.9209 10V1.46875C2.9209 1.08125 3.05215 0.756249 3.31465 0.493749C3.57715 0.231249 3.8959 0.0999985 4.2709 0.0999985H10.5521C10.9396 0.0999985 11.2646 0.231249 11.5271 0.493749C11.7896 0.756249 11.9209 1.08125 11.9209 1.46875V10C11.9209 10.375 11.7896 10.6937 11.5271 10.9562C11.2646 11.2187 10.9396 11.35 10.5521 11.35H4.2709ZM4.2709 10.225H10.5521C10.6146 10.225 10.6709 10.203 10.7209 10.159C10.7709 10.1155 10.7959 10.0625 10.7959 10V1.46875C10.7959 1.40625 10.7709 1.35 10.7209 1.3C10.6709 1.25 10.6146 1.225 10.5521 1.225H4.2709C4.2084 1.225 4.1554 1.25 4.1119 1.3C4.0679 1.35 4.0459 1.40625 4.0459 1.46875V10C4.0459 10.0625 4.0679 10.1155 4.1119 10.159C4.1554 10.203 4.2084 10.225 4.2709 10.225Z"
                fill="#404041"
              />
            </svg>
          </div>
        </div>
      </div>
    </div>
  );
}

export default BlogCard;
